import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from '@material-ui/core';

const messages = defineMessages({
  CANCEL: {
    id: 'CANCEL',
    defaultMessage: 'Cancel',
  },
});

function ConfirmationAction({
  children,
  confirmActionMsg,
  confirmBody,
  confirmMsg,
  onConfirm,
  onClose,
  tooltipMsg,
}) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    if (onClose) onClose();
  };

  const handleConfirm = () => {
    setOpen(false);
    onConfirm();
  };

  return (
    <>
      <Tooltip disableFocusListener title={tooltipMsg}>
        {React.cloneElement(children, {
          onClick: handleClickOpen,
        })}
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {confirmMsg}
        </DialogTitle>

        {confirmBody && (
          <DialogContent>
            <DialogContentText>
              {confirmBody}
            </DialogContentText>
          </DialogContent>
        )}

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            <FormattedMessage {...messages.CANCEL} />
          </Button>

          <Button onClick={handleConfirm} color="primary" autoFocus>
            {confirmActionMsg}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

ConfirmationAction.defaultProps = {
  onClose: undefined,
};

ConfirmationAction.propTypes = {
  onClose: PropTypes.func,
  onConfirm: PropTypes.func.isRequired, // what to do when confirmed
  confirmMsg: PropTypes.shape({}).isRequired, // the dialog text, provided as intl object
  confirmActionMsg: PropTypes.shape({}).isRequired, // the primary action, eg: "Save","Accept",etc, provided as intl object
  tooltipMsg: PropTypes.shape({}).isRequired, // tooltip for the action element, provided as intl object
  children: PropTypes.element.isRequired, // the element to bind the dialog to
};

export default ConfirmationAction;
